import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { InputWithLabel } from '@reveni-io/reveni-ui'

const PaymentWindowInput = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()
  const [showError, setShowError] = useState(false)

  const handleChange = e => {
    const value = e.target.value

    if (Number(value) >= 0) {
      onChange(value)
      setShowError(value > 48 || value < 1)
    } else {
      onChange('')
      setShowError(true)
    }
  }

  return (
    <InputWithLabel
      label={t('Ventana de pago para pedidos con pago pendiente (en horas)')}
      helperText={!showError ? t('Mín. 1. Máx. 48') : t('El valor debe estar entre 1 y 48')}
      fullWidth
      onChange={handleChange}
      value={value}
      error={showError}
      disabled={disabled}
    />
  )
}

export default PaymentWindowInput
